import { render, staticRenderFns } from "./edit-xf.vue?vue&type=template&id=5078dc00&scoped=true"
import script from "./edit-xf.vue?vue&type=script&lang=js"
export * from "./edit-xf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5078dc00",
  null
  
)

export default component.exports